import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutMovement, WorkoutMovementWrite } from 'types';
import { client } from 'utils/api-client';

interface IUpdateWorkoutMovement {
  workoutMovementId: string;
  data: WorkoutMovementWrite;
}

export default function useUpdateWorkoutMovement(): UseMutationResult<
  AxiosResponse<WorkoutMovement>,
  AxiosError<ErrorMessage>,
  IUpdateWorkoutMovement
> {
  const queryClient = useQueryClient();

  const updateWorkoutMovement = ({
    workoutMovementId,
    data,
  }: IUpdateWorkoutMovement): Promise<AxiosResponse<WorkoutMovement>> => {
    return client.put(`workout-movements/${workoutMovementId}/`, data);
  };

  return useMutation(updateWorkoutMovement, {
    onSuccess: () => {
      queryClient.invalidateQueries('workoutMovements');
    },
  });
}
